/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./AdjustmentDetails.module.css";

const CommentSection: React.FC = () => {
  return (
    <div className={styles.commentSection}>
      <label htmlFor="comment" className={styles.commentLabel}>
        Comment
      </label>
      <div className={styles.commentTextarea}>
        <textarea id="comment" className={styles.textareaInput} />
      </div>
    </div>
  );
};

export default CommentSection;
